import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = { class: "pa-1 today-wrapper" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = {
  key: 0,
  class: "login_user_badge pa-1 ml-1 body-2 bg-light-blue-lighten-2 text-white"
}
const _hoisted_6 = {
  key: 0,
  class: "badge d-flex justify-center align-center mr-2"
}
const _hoisted_7 = { class: "px-5 py-2" }
const _hoisted_8 = { class: "pa-1 today-wrapper" }
const _hoisted_9 = { class: "badge d-flex justify-center align-center mr-2" }
const _hoisted_10 = { class: "px-5 py-2" }
const _hoisted_11 = { class: "pa-1 today-wrapper" }
const _hoisted_12 = { class: "badge d-flex justify-center align-center mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        class: "position-relative"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            icon: "",
            variant: "text"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, {
            class: "flex-grow-1 text-center ml-0",
            style: {"pointer-events":"none"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('settingFamily.title')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            icon: "",
            disabled: "",
            style: {"visibility":"hidden"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.t('settingFamily.guardians')), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_list, {
        lines: "two",
        density: "compact"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parents, (p, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: p.parentId
            }, [
              _createVNode(_component_v_list_item, {
                onClick: ($event: any) => (_ctx.toParent('/parent/edit', 'ParentEdit', p.isLoginUser))
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, { class: "ml-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _ctx.resolveChildImageUrl(p.imageUrl) || undefined
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                append: _withCtx(() => [
                  (p.isLoginUser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-chevron-right", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "font-weight-bold subtitle-1" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", null, _toDisplayString(p.lastName + p.firstName), 1),
                        (p.isLoginUser)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.t('settingFamily.you')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_list_item_subtitle, { class: "subtitle-2 text-grey-darken-5" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatParentType(p.parentType)), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_v_divider)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_v_btn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.to('/parent/add', 'ParentAdd'))),
        color: "primary",
        variant: "outlined",
        block: "",
        small: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.t('settingFamily.inviteGuardian')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.t('settingFamily.children')), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_list, {
        lines: "two",
        density: "compact"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: c.childId
            }, [
              _createVNode(_component_v_list_item, {
                onClick: ($event: any) => (_ctx.toChild('/child/edit', 'ChildEdit', c.childId, c.lastName + c.firstName))
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, { class: "ml-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: _ctx.resolveChildImageUrl(c.imageUrl) || undefined
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                append: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "font-weight-bold subtitle-1" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(c.lastName + c.firstName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_v_divider)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_v_btn, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.to('/child/add', 'ChildAdd'))),
        color: "primary",
        variant: "outlined",
        block: "",
        small: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.t('settingFamily.addChild')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.t('settingFamily.familyInfo')), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_list, {
        lines: "two",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.to('/family/edit', 'FamilyEdit')))
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_v_avatar, { class: "ml-2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, { src: "https://via.placeholder.com/240x180?text=Sample+Image+1" })
                ]),
                _: 1
              })
            ]),
            append: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, { class: "font-weight-bold subtitle-1" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.family?.familyName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider)
        ]),
        _: 1
      })
    ])
  ]))
}